'use client';
import { useEffect, useState } from 'react';
import { usePathname } from 'next/navigation';
import Link from 'next/link';
import { clsx } from 'clsx';
import { headerMainMenu } from '@/constants/navMenu';
import s from './HeaderNav.module.scss';

export const HeaderNav = () => {
  const [isOpen, setIsOpen] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const closeDropdown = () => setIsOpen(false);
    document.addEventListener('click', closeDropdown);

    return () => document.removeEventListener('click', closeDropdown);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  return (
    <nav className={clsx(s.nav)}>
      <ul className={clsx(s.nav__list)}>
        {headerMainMenu.map((item, i) => {
          if (item.isHidden) return null;

          const isActive = pathname.includes(item.path);
          const classes = isActive ? `${s.nav__link} ${s.nav__link_active}` : s.nav__link;

          return (
            <li key={item.id} className={clsx(s.nav__item, {
              [s.nav__item_hidden]: item.isHidden,
              [s.nav__item_desktop]: i > headerMainMenu.length - 4,
            })}>
              <Link
                scroll={false}
                href={item.path}
                className={classes}
              >
                {item.title}
              </Link>
            </li>
          );
        })}

        <li className={`${s.nav__item} ${s.nav__item_last}`}>
          <div
            onClick={() => setIsOpen(!isOpen)}
            className={clsx(s.nav__link, { [s.nav__link_active]: isOpen })}
          >
            Ещё
          </div>
          <ul className={clsx(s.burgerDropdown, { [s.burgerDropdown_opened]: isOpen })}>
            {headerMainMenu.slice(-3).map((item) => {
              return (
                <li key={item.id}>
                  <Link
                    scroll={false}
                    href={item.path}
                    className={s.burgerDropdown__item}
                  >
                    {item.title}
                  </Link>
                </li>
              );
            })}
          </ul>
        </li>
      </ul>
    </nav>
  );
};